import { backendService } from "src/core/backend/services/backendService";
import { create } from "zustand";
import type {
  UpdateUserPasswordRequest,
  UpdateUserRequest,
  UserResponse,
} from "../../../core/backend/clients/backendClient";
import { logService } from "../../../core/services/logService";
import { profileService } from "./profileService";

interface ProfileState {
  readonly loading: boolean;

  clear: () => void;

  updateUser: (request: UpdateUserRequest) => Promise<UserResponse>;
  updatePassword: (request: UpdateUserPasswordRequest) => Promise<void>;

  deleteUser: () => Promise<void>;
}

export const useProfileStore = create<ProfileState>()((set) => ({
  loading: false,

  clear: () => {
    set({
      loading: false,
    });
  },

  updateUser: async (request: UpdateUserRequest) => {
    set({ loading: true });

    backendService.nullToUndefined(request);
    backendService.personRequestFix(request);

    return await profileService
      .updateUser(request)
      .then((response) => {
        set({ loading: false });
        backendService.personResponseFix(response);
        if (logService.globalLog)
          logService.info("updateUser response", response);
        return response;
      })
      .catch((error) => {
        logService.error("updateUser", error);
        set({ loading: false });
        throw error;
      });
  },

  updatePassword: async (request: UpdateUserPasswordRequest) => {
    set({ loading: true });

    await profileService
      .updatePassword(request)
      .then(() => {
        if (logService.globalLog) logService.info("updatePassword");
      })
      .catch((error) => {
        logService.error("updatePassword", error);
        set({ loading: false });
        throw error;
      });

    set({ loading: false });
  },

  deleteUser: async () => {
    set({ loading: true });

    await profileService
      .deleteUser()
      .then(() => {
        if (logService.globalLog) logService.info("deleteUser");
      })
      .catch((error) => {
        logService.error("deleteUser", error);
        set({ loading: false });
        throw error;
      });

    set({ loading: false });
  },
}));
